import {ChangeDetectorRef, Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { UpdateService } from "./services/update/update.service";
import { Router } from '@angular/router';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { TranslateService } from '@ngx-translate/core';
import { AlertController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authguard/authentication.service';

import { FCM } from "cordova-plugin-fcm-with-dependecy-updated/ionic";
import { MenuController } from '@ionic/angular';
import { ThemeSwitcherService } from './services/themeswitcher/theme-switcher.service';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  language_key: any;

  source_from: any
  isSmallScreen: boolean;
  private readonly mobileQuery: MediaQueryList;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private authenticationService: AuthenticationService,
    private updateservice: UpdateService,
    private router: Router,
    private androidPermissions: AndroidPermissions,
    private _translate: TranslateService,
    private menu: MenuController,
    public alertController: AlertController,
    public auth: AuthenticationService,
    private themeSwitcherService: ThemeSwitcherService,
       changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {

    this.initializeApp();
    // this.languageService.setInitialAppLanguage();
    this.mobileQuery = media.matchMedia('(max-width: 720px)');
    this.isSmallScreen = this.mobileQuery.matches;

    this.mobileQuery.addEventListener('change', () => {
      changeDetectorRef.detectChanges();
      this.isSmallScreen = this.mobileQuery.matches;
    });
  

  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleLightContent()
      this.splashScreen.hide();
      this.themeSwitcherService.setTheme('bespoke')

      if (this.platform.is('android')) {
        this.source_from = 2;
      }
      else if (this.platform.is('ios')) {
        this.source_from = 3;
      }
      else {
        this.source_from = 4;
      }

      if (this.platform.is("android") || this.platform.is("ios")) {
        this.updateservice.descideUpdateAction(this.source_from);
      }
      this.authenticationService.authenticationState.subscribe(state => {
        let url = window.localStorage.getItem('pageUrl');
        if (state) {
          // (url)? this.router.navigate([url]):this.router.navigate(['/rootTabs']);
          this.router.navigate(['/tabs']);
          // this.router.navigate(['/tabs/dashboard/user-profile/edit-profile'])

        } else {
          this.router.navigate(['/login']);
          // this.router.navigate(['/password']);
        }
      });
      // let status bar overlay webview
      // this.statusBar.overlaysWebView(true);
      // set status bar to white
      this.statusBar.overlaysWebView(false);
      this.statusBar.backgroundColorByHexString('#000000');
      this.statusBar.styleDefault();

      this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION)
        .then(
          result => console.log('Has permission?', result.hasPermission),
          err => this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION)
        )
      this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.CAMERA)
        .then(
          result => console.log('Has permission?', result.hasPermission),
          err => this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.CAMERA)
        )
      if (localStorage.getItem('langTxt') == null || localStorage.getItem('langTxt') == undefined) {
        let langTxt = 'en'
        localStorage.setItem('langTxt', 'en');
        this._translate.setDefaultLang(langTxt);
        console.log(localStorage.getItem('langTxt'))
      }
      else {
        let langTxt = localStorage.getItem('langTxt');
        this._translate.setDefaultLang(langTxt);
        console.log(localStorage.getItem('langTxt'))
      }
      if (this.platform.is('cordova')) {
        FCM.requestPushPermission().then((res) => {

          console.log("Permission accepted")

        }, (err) => {

          console.log("Permission rejected")

        })

        FCM.getToken().then(token => {
          debugger
          localStorage.setItem('fcm', token)
        }).catch(err => console.log('err:::', err));

        FCM.onNotification().subscribe(data => {
          if (data.wasTapped) {
            console.log("Received in background");
          } else {
            console.log("Received in foreground");
          };
        });

        FCM.onTokenRefresh().subscribe(token => {
          // backend.registerToken(token);

          console.log('refresh token', token)
          localStorage.setItem('fcm', token)
        });

        FCM.hasPermission().then(hasPermission => {
          if (hasPermission) {
            console.log("Has permission!");
          } else {
            console.log('No permission')
            FCM.requestPushPermission().then((res) => {

              console.log("Permission accepted")

            }, (err) => {

              console.log("Permission rejected")

            })
          }
        })

        FCM.clearAllNotifications();
      }

    });
    this.platform.resume.subscribe(async () => {
      //Check for updates
      if (this.platform.is("android") || this.platform.is("ios")) {
        this.updateservice.descideUpdateAction(this.source_from);
      }

    });
  }
}
